/**
 * Song Live / Chords View Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Live Song/Chords guide.
 */
export const songLiveTourConfig = {
  id: 'song-live-onboarding',
  storageKey: 'triad_tour_song_live_completed',
  steps: [
    {
      id: 'song-list-toggle',
      target: '[data-tour="song-list-toggle"]',
      titleKey: 'tour.songLive.listTitle',
      descriptionKey: 'tour.songLive.listDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'song-header',
      target: '[data-tour="song-header"]',
      titleKey: 'tour.songLive.headerTitle',
      descriptionKey: 'tour.songLive.headerDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'favorite-tools',
      target: () => {
        const quickActions = document.querySelector('[data-tour="quick-actions-btn"]');
        if (quickActions && (quickActions.offsetWidth > 0 || quickActions.getClientRects().length > 0)) {
          return quickActions;
        }
        return document.querySelector('[data-tour="favorite-tools"]');
      },
      titleKey: 'tour.songLive.toolsTitle',
      descriptionKey: 'tour.songLive.toolsDesc',
      position: 'bottom',
      align: 'end',
      allowMissing: true
    },
    {
      id: 'song-viewer',
      target: '[data-tour="song-viewer"]',
      titleKey: 'tour.songLive.viewerTitle',
      descriptionKey: 'tour.songLive.viewerDesc',
      position: 'top',
      align: 'center'
    }
  ]
};

export default songLiveTourConfig;
